(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-header"]) return;
  try {
    
if (!customElements.get('vp-product-menu')) {
  customElements.define('vp-product-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector('details');
      const summary = details?.querySelector(':scope > summary');
      if (!summary) return;
      const desktop = details.classList.contains('vp-product-disclosure');
      const hover = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
      let keyboard = false;
      const cancel = () => clearTimeout(this.closeTimer);
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      const close = () => { cancel(); details.open = false; this.querySelectorAll('details[open]').forEach(item => item.open = false); sync(); };
      this.addEventListener('pointerenter', event => { if (!desktop || !hover.matches || event.pointerType !== 'mouse') return; cancel(); keyboard = false; details.open = true; sync(); }, { signal });
      this.addEventListener('pointerleave', event => { if (!desktop || !hover.matches || event.pointerType !== 'mouse') return; cancel(); this.closeTimer = setTimeout(() => { if (!keyboard || !this.contains(document.activeElement)) close(); }, 180); }, { signal });
      this.addEventListener('keydown', event => { keyboard = true; cancel(); if (event.key === 'Escape' && details.open) { event.preventDefault(); close(); summary.focus(); } }, { signal });
      this.addEventListener('pointerdown', () => { keyboard = false; }, { signal });
      this.addEventListener('focusout', event => { if (keyboard && !this.contains(event.relatedTarget)) close(); }, { signal });
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, { signal });
      details.addEventListener('toggle', sync, { signal });
      hover.addEventListener('change', close, { signal });
      sync();
    }
    disconnectedCallback() { clearTimeout(this.closeTimer); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
